import MembershipOfSelectCommitteesFilters, {
  LordSelectCommitteesFilters,
} from './MembershipOfSelectCommitteesFilters';
import MembershipOfAPPGsFilters, { MembershipOfCrossPartyGroupsFilters } from './MembershipOfAPPGsFilters';
import RegionFilters from './RegionFilters';
import ConfigData from 'config/ConfigData';
import getAppSite from 'utils/getAppSite';

const RoleOptions = ConfigData?.filters?.role?.options ?? [];
const RoleSearchOptions = ConfigData?.filters?.role?.searchOptions ?? [];
const PartyOptions = ConfigData?.filters?.party?.options ?? [];
const NationOptions = ConfigData?.filters?.nation?.options ?? [];
const SortModeOptions = ConfigData?.filters?.sortMode?.options ?? [];

const PositionOptions = [
  {
    name: 'Cabinet',
  },

  {
    name: 'Government',
  },

  {
    name: 'Shadow Cabinet',
  },

  {
    name: 'Shadow Government',
  },

  {
    name: 'Parliamentary Private Secretaries',
    filterValue: 'Parliamentary Private Secretary',
  },

  {
    name: 'Backbenchers',
    filterValue: 'Backbencher',
  },
];

const StakeholdersFilters = [
  {
    label: 'Legislature',
    name: 'Nation',
    pages: ['Stakeholders'],
    searchState: 'list',
    filterName: 'nations',
    type: 'sort',
    collapseOnSelect: true,
    customOrder: 0,
    optionSelected: ConfigData?.filters?.nation?.optionSelected,
    subtextClassName: 'nations-sort-subtext',
    options: NationOptions,
    configHidden: ConfigData?.filters?.nation?.configHidden,
    hidden: ConfigData?.filters?.nation?.hidden,
  },
  {
    name: 'Sort',
    pages: ['Stakeholders'],
    searchState: 'list',
    type: 'sortMode',
    optionSelected: getAppSite() === 'usa' ? 'Most vocal' : 'Most relevant',
    customOrder: 0,
    options: [
      ...SortModeOptions,
      {
        name: 'Most vocal',
        description: `Based on relevant parliamentary contributions ${
          import.meta.env.VITE_APP_ENABLE_TWITTER === 'false' ? '' : 'and Tweets'
        }`,
        tiptext: 'contributions',
        filterValue: 'TotalContributions',
        order: 2,
      },
      {
        name: 'Most positive',
        activePlanCondition: 'enableSentiment',
        description: 'Based on sentiment analysis of relevant contributions',
        filterValue: 'MostPositive',
        order: 3,
      },
      {
        name: 'Most negative',
        activePlanCondition: 'enableSentiment',
        description: 'Based on sentiment analysis of relevant contributions',
        filterValue: 'MostNegative',
        order: 4,
      },
    ],
  },
  {
    name: 'Search within results',
    searchState: 'activeSearch',
    pages: ['Stakeholders'],
    type: 'search',
    value: '',
    updateFilter: true,
  },
  {
    name: 'Sort',
    searchState: 'allResults',
    type: 'sort',
    pages: ['Stakeholders'],
    hidden: true,
    optionSelected: 'Last name ascending',
    options: [
      {
        name: 'Last name ascending',
        filter: [
          {
            pages: ['Stakeholders'],
            property: { field: 'lastName', order: 'ASC' },
          },
        ],
      },
    ],
  },
  {
    name: 'Sort',
    searchState: 'referenceSection',
    type: 'sort',
    pages: ['Stakeholders'],
    hidden: true,
    optionSelected: 'Position category rank',
    options: [
      {
        name: 'Position category rank',
        filter: [
          {
            pages: ['Stakeholders'],
            property: { field: 'positionCategoryRank', order: 'DESC' },
          },
        ],
      },
    ],
  },
  //AE: Difference is on SearchState
  {
    name: 'Role',
    pages: ['InfluenceContacts'],
    searchState: 'always',
    filterName: 'categories',
    optionSelected: '',
    options: [...RoleOptions, ...RoleSearchOptions],
    prefix: 'role',
    customOrder: 2,
  },
  {
    name: 'Role',
    pages: ['Stakeholders'],
    searchState: 'SeneddOrHolyroodCondition',
    filterName: 'categories',
    optionSelected: '',
    options: RoleOptions,
    prefix: 'role',
    customOrder: 2,
  },
  {
    name: 'Include staff',
    searchState: 'searchResultsSection',
    pages: ['Stakeholders'],
    filterName: 'categories',
    filterValue: 'Westminster Staffer',
    operator: 'str_eq',
    type: 'toggle',
    configHidden: ConfigData?.filters?.includeStaff?.configHidden,
    customOrder: 2,
    value: false,
  },
  {
    name: 'Role',
    pages: ['Stakeholders'],
    searchState: 'searchResultsSection',
    filterName: 'categories',
    optionSelected: '',
    options: [
      ...RoleOptions?.map((item) => {
        return { ...item, selected: true };
      }),
      ...RoleSearchOptions?.filter((item) => !item?.name?.includes('Staff'))?.map((item) => {
        return { ...item, selected: true };
      }),
    ],
    prefix: 'role',
    customOrder: 2,
  },
  {
    name: 'Position',
    pages: ['Stakeholders', 'InfluenceContacts'],
    searchState: 'SeneddOrHolyroodCondition',
    filterName: 'positionCategories',
    optionSelected: '',
    options: PositionOptions,
    prefix: 'position',
    customOrder: 3,
    configHidden: ConfigData?.filters?.position?.configHidden,
  },
  {
    name: 'Department',
    pages: ['InfluenceContacts', 'Stakeholders'],
    type: 'membership',
    subtype: 'DepartmentSelectType',
    searchState: 'always',
    filterName: 'departments',
    options: [],
    prefix: 'dep',
    optionSelected: '',
    customOrder: 4,
    configHidden: ConfigData?.filters?.department?.configHidden,
  },
  {
    name: 'Party',
    pages: ['Stakeholders', 'InfluenceContacts'],
    additionalItemsText: 'parties',
    searchState: 'always',
    filterName: 'party',
    optionSelected: '',
    options: PartyOptions,
    prefix: 'party',
    updateFilter: true,
    customOrder: 5,
  },
  {
    type: 'membership',
    subtype: 'usStateOptions',
    prefix: 'state',
    name: 'State',
    searchState: 'always',
    pages: ['Stakeholders'],
    filterName: 'constituency',
    optionSelected: '',
    options: [],
    configHidden: ConfigData?.filters?.state?.configHidden,
    customOrder: 6,
  },
  ...RegionFilters,
  {
    name: 'Sentiment',
    pages: ['Stakeholders'],
    searchState: 'sentimentSortModeCondition',
    filterName: 'aggregatedSentiment',
    optionSelected: '',
    conditionFilter: 'sortMode',
    condititonsOptionsToShow: ['Most negative', 'Most positive'],
    options: [
      {
        name: 'Positive contributors',
        filterValue: 'Positive',
        hash: 'positive',
      },

      {
        name: 'Mixed contributors',
        filterValue: 'Mixed',
        hash: 'mixed',
      },

      {
        name: 'Neutral contributors',
        filterValue: 'Neutral',
        hash: 'neutral',
      },

      {
        name: 'Negative contributors',
        filterValue: 'Negative',
        hash: 'negative',
      },
    ],
    prefix: 'sentiment',
  },
  ...MembershipOfSelectCommitteesFilters,
  ...LordSelectCommitteesFilters,
  ...MembershipOfAPPGsFilters,
  ...MembershipOfCrossPartyGroupsFilters,
  //AE: This filter is the one shown when the user has not the property on their plan.
  {
    name: 'Sentiment',
    pages: ['Stakeholders'],
    searchState: 'disabledPlanFieldOption',
    disabled: true,
    activePlanProperty: 'enableSentiment',
    filterName: 'aggregatedSentiment',
    optionSelected: '',
    options: [
      {
        name: 'Positive contributors',
        filterValue: 'Positive',
        hash: 'positive',
      },

      {
        name: 'Mixed contributors',
        filterValue: 'Mixed',
        hash: 'mixed',
      },

      {
        name: 'Neutral contributors',
        filterValue: 'Neutral',
        hash: 'neutral',
      },

      {
        name: 'Negative contributors',
        filterValue: 'Negative',
        hash: 'negative',
      },
    ],
    prefix: 'sentiment',
  },
];

export { PartyOptions, RoleOptions, RoleSearchOptions, PositionOptions, NationOptions };
export default StakeholdersFilters;
